import { MenuItemType } from '@/app/types/layout'

export type UserDropdownItemType = {
  label?: string;
  icon?: string;
  url?: string;
  isDivider?: boolean;
  isHeader?: boolean;
  class?: string;
  actionKey?: 'logout' | 'none' | 'changepass';
}

export const userDropdownItems: UserDropdownItemType[] = [
  {
    label: 'Bienvenido!',
    isHeader: true
  },
  {
    label: 'Profile',
    icon: 'tablerUserCircle',
    url: 'pages-profile.html'
  },
  {
    isDivider: true
  },
  {
    label: 'Lock Screen',
    icon: 'tablerLock',
    url: 'auth-lock-screen.html'
  },
  {
    label: "Cambiar Contraseña",
    icon: "tablerKey",
    actionKey: 'changepass'
  },
  {
    label: 'Cerrar sesión',
    icon: 'tablerLogout2',
    class: 'text-danger fw-semibold',
    actionKey: 'logout'
  }

]

export const menuItems: MenuItemType[] = [
  {
    label: 'Inicio',
    icon: 'tablerLayoutDashboard',
    url: '/dashboard'
  },
  {
    label: 'Mantenimiento',
    icon: 'tablerCategory',
    isCollapsed: true,
    children: [
      {
        label: 'Solicitudes',
        icon: 'tablerCheckupList',
        url: '/mantenimiento/solicitudes'
      },
      {
        label: 'Orden de Servicio',
        icon: 'tablerMap',
        isCollapsed: true,
        children: [
          {
            label: 'Redes agua potable',
            icon: 'tablerDroplet',
            url: '/mantenimiento/orden-servicio/agua-potable'
          },
          {
            label: 'Servicio de alcantarillado',
            icon: 'tablerToiletPaper',
            url: '/mantenimiento/orden-servicio/servicio-alcantarillado'
          },
          {
            label: 'Equipos electromecánicos',
            icon: 'tablerBolt',
            url: '/mantenimiento/orden-servicio/equipos-electromecanicos'
          },
          {
            label: 'Resumen detallado',
            icon: 'tablerClipboardList',
            url: '/mantenimiento/orden-servicio/detallado'
          }
        ]
      },
      {
        label: 'Mantenimiento Preventivo',
        icon: 'tablerSitemap',
        url: '/mantenimiento/preventivo'
      },
      {
        label: 'Medidores',
        icon: 'tablerPalette',
        url: '/mantenimiento/medidores',
        isCollapsed: true,
        children: [
          {
            label: 'Marca',
            icon: 'tablerBrandMedium',
            url: '/mantenimiento/medidores/marca'
          },
          {
            label: 'Tipo',
            icon: 'tablerBrandFramer',
            url: '/mantenimiento/medidores/tipo'
          },
          {
            label: 'Capacidad',
            icon: 'tablerMeterCube',
            url: '/mantenimiento/medidores/capacidad'
          },
          {
            label: 'Diámetro',
            icon: 'tablerVectorBezier',
            url: '/mantenimiento/medidores/diametro'
          },
          {
            label: 'Estado',
            icon: 'tablerEngineOff',
            url: '/mantenimiento/medidores/estado'
          }
        ]
      },
      {
        label: 'Personal',
        icon: 'tablerUsers',
        url: '/mantenimiento/personal'
      },
      {
        label: 'Materiales',
        icon: 'tablerIcons',
        url: '/mantenimiento/materiales'
      },
      {
        label: 'Vehículos',
        icon: 'tablerCar',
        url: '/mantenimiento/vehiculos'
      }
      // {label: 'Test', icon: 'tablerLayout', url: '/test'},
    ]
  },
  {
    label: 'Infraestructura',
    icon: 'tablerHomeLink',
    isCollapsed: true,
    children: [
      {
        label: 'Local de Operación',
        icon: 'tablerHomeCog',
        url: '/infraestructura/local-operacion'
      },
      {
        label: 'Instalación',
        icon: 'tablerBrandPnpm',
        url: '/infraestructura/instalaciones'
      },
      /* {label: 'SubInstalación', icon: 'tablerBrandPnpm', url: '/infraestructura/subinstalaciones'},*/
      {
        label: 'Equipos',
        icon: 'tablerAdjustmentsCog',
        url: '/infraestructura/equipos'
      }
    ]
  },
  {
    label: 'Operaciones',
    icon: 'tablerActivity',
    isCollapsed: true,
    children: [
        {
          label: 'P. agua cruda',
          icon: 'tablerDroplet',
          url: '/operaciones/produccion-agua-cruda'
        },
        {
          label: 'P. agua potable',
          icon: 'tablerBottle',
          url: '/operaciones/produccion-agua-potable'
        },
        {
          label: 'Reservorios',
          icon: 'tablerBuildingStore',
          url: '/operaciones/reservorios'
        },
        {
          label: 'G. de insumos químicos',
          icon: 'tablerFlask',
          url: '/operaciones/gestion-insumos-quimicos'
        },
        {
          label: 'Reportes de operación',
          icon: 'tablerReport',
          url: '/operaciones/reportes-operacion'
        },

      ]
  },
  {
    label: 'Laboratorios',
    icon: 'tablerFlask',
    isCollapsed: true,
    children:[
      {
        label: 'Captación',
        icon: 'tablerDroplet',
        url: '/laboratorio/captacion'
      },
      {
        label: 'Planta',
        icon: 'tablerBottle',
        url: '/laboratorio/planta'
      },
      {
        label: 'Reservorios',
        icon: 'tablerBuildingStore',
        url: '/laboratorio/reservorios'
      },
      {
        label: 'Redes',
        icon: 'tablerNetwork',
        url: '/laboratorio/redes'
      }
    ]
  },
  {
    label: 'Administración',
    icon: 'tablerSettings',
    isCollapsed: true,
    children: [
      { label: 'Roles', icon: 'tablerUserCheck', url: '/main/roles' },
      { label: 'Usuarios', icon: 'tablerUsers', url: '/main/users' },
      {label: 'Opciones de Menú', icon: 'tablerListCheck', url: '/main/menus'},
      {
        label: 'Personas',
        icon: 'tablerUsersPlus',
        url: '/main/personas'
      }
      //{label: 'Rutas', icon: 'tablerRoute', url: '/main/rutas'},
    ]
  }
]

export const horizontalMenuItems: MenuItemType[] = [
  {
    label: 'Dashboard',
    icon: 'tablerLayoutDashboard',
    url: '/dashboard'
  },
  {
    label: 'Pages',
    icon: 'tablerFiles',
    children: [
      {
        label: 'Authentication 1',
        icon: 'tablerShieldLock',
        children: [
          { label: 'Sign In', url: '/auth/sign-in' },
          { label: 'Sign Up', url: '/auth/sign-up' },
          { label: 'Reset Password', url: '/auth/reset-pw' },
          { label: 'New Password', url: '/auth/new-pw' },
          { label: 'Two Factor', url: '/auth/two-factor' },
          { label: 'Lock Screen', url: '/auth/lock-screen' },
          { label: 'Success Mail', url: '/auth/success-mail' },
          { label: 'Login with PIN', url: '/auth/login-pin' },
          { label: 'Delete Account', url: '/auth/delete-account' }
        ]
      },
      {
        label: 'Authentication 2',
        icon: 'tablerUserHexagon',
        children: [
          { label: 'Sign In', url: '/auth-2/sign-in' },
          { label: 'Sign Up', url: '/auth-2/sign-up' },
          { label: 'Reset Password', url: '/auth-2/reset-pw' },
          { label: 'New Password', url: '/auth-2/new-pw' },
          { label: 'Two Factor', url: '/auth-2/two-factor' },
          { label: 'Lock Screen', url: '/auth-2/lock-screen' },
          { label: 'Success Mail', url: '/auth-2/success-mail' },
          { label: 'Login with PIN', url: '/auth-2/login-pin' },
          { label: 'Delete Account', url: '/auth-2/delete-account' }
        ]
      },
      {
        label: 'Authentication 3',
        icon: 'tablerLockAccess',
        children: [
          { label: 'Sign In', url: '/auth-3/sign-in' },
          { label: 'Sign Up', url: '/auth-3/sign-up' },
          { label: 'Reset Password', url: '/auth-3/reset-pw' },
          { label: 'New Password', url: '/auth-3/new-pw' },
          { label: 'Two Factor', url: '/auth-3/two-factor' },
          { label: 'Lock Screen', url: '/auth-3/lock-screen' },
          { label: 'Success Mail', url: '/auth-3/success-mail' },
          { label: 'Login with PIN', url: '/auth-3/login-pin' },
          { label: 'Delete Account', url: '/auth-3/delete-account' }
        ]
      },
      {
        label: 'Error Pages',
        icon: 'tablerAlertHexagon',
        children: [
          { label: '400', url: '/error/400' },
          { label: '401', url: '/error/401' },
          { label: '403', url: '/error/403' },
          { label: '404', url: '/error/404' },
          { label: '408', url: '/error/408' },
          { label: '500', url: '/error/500' },
          { label: 'Maintenance', url: '/maintenance' }
        ]
      }
    ]
  }
]
